import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import type { MutationError } from '~/types/form';
import { PACKAGE_SESSION_QUOTATION } from '~/endpoints';
import { handleErrorResponse } from '~/helpers/api';
import { PackageSessionQuotationRequest } from '~/types/api';
import { PackageSessionQuotationResponseSchema } from '~/validation/api/packageSessionQuotationResponse';

const sendPackageSessionQuoteRequest = async (obj: PackageSessionQuotationRequest) => {
  try {
    const response = await axios.post(PACKAGE_SESSION_QUOTATION, obj);

    const json = response.data;

    return PackageSessionQuotationResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export default function usePackageSessionQuotation() {
  return useMutation<any, MutationError, PackageSessionQuotationRequest>({
    mutationFn: (obj) => {
      return sendPackageSessionQuoteRequest(obj);
    },
  });
}
